'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _commonFunctions = require('../../helpers/commonFunctions');

/**
 * Transforms the data in a Redux Form component to the format required by the API.
 * The data should be in the form given by this.props.values in the connected Redux Form
 *   component.
 * @param {Object} formValues - The form values to transform.
 * @param {Object} trackingCode - The referral code.
 * @returns {Object} - The transformed values.
 */
exports.default = function (formConfig, formValues, trackingCode) {
  var applicant = formValues.applicant,
      _formValues$applicati = formValues.application,
      additional_data = _formValues$applicati.additional_data,
      effective_date = _formValues$applicati.effective_date,
      expiry_date = _formValues$applicati.expiry_date;


  var payload = _extends({}, (0, _commonFunctions.transformApplication)(formValues, trackingCode), {
    expiry_date: expiry_date
  });

  if ((0, _commonFunctions.associatedForm)()) {
    payload.associated_policy = formValues.application.associated_policy || '';
    payload.relationship_to_student = formValues.applicant[0].additional_data.relationship_to_primary_applicant;
  }

  if ((0, _commonFunctions.renewalForm)()) {
    payload.additional_data.existing_policy = formValues.application.additional_data.existing_policy || '';
  }

  if (!formValues.application.additional_data.school || formValues.application.additional_data.school.trim().length === 0) {
    payload.additional_data.school = 'N/A';
  }
  return payload;
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/transformers/student/application.js
// module id = 1743
// module chunks = 0